import {Component}                       from '@angular/core';
import {Timestamp}                       from '@angular/fire/firestore';
import {MedsConfIntf, MedsRecordLogIntf} from '@djsharkk/logr-types';
import {combineLatest, takeUntil}        from 'rxjs';
import {MenuCrudPanelContentBase}        from '../../menu-crud-panel-content-base';
import {MenuCrudPanelTopComponent}       from '../menu-crud-panel-top.component';


@Component({
			   selector   : 'app-menu-crud-meds',
			   imports : [
				   MenuCrudPanelTopComponent
			   ],
			   templateUrl: './menu-crud-panel-meds-top.component.html',
			   styleUrl: './menu-crud-panel-meds-top.component.css'
		   })
export class MenuCrudPanelMedsTopComponent extends MenuCrudPanelContentBase<MedsRecordLogIntf, MedsConfIntf> {


	constructor() {
		super('meds', false);

		combineLatest({
						  list: this.svcDataFactory.svcDataMeds.medsList,
						  conf: this.svcDataFactory.svcDataMeds.medsConf
					  })
			.pipe(takeUntil(this.destroy$))
			.subscribe(payload => {

				this.recordConfBtns = [
					...payload.list.map((med, index) => ({
						uuid: med.id as string,
						icon: index.toString().padStart(2, `0`),
						text: [
							...med.medication.split(' '),
							`${med.dosage}${med.unit}`
						],
						func: () => {
							const medRecord: MedsRecordLogIntf = {
								timestamp : Timestamp.now(),
								medication: med.id,
								dosage    : med.dosage,
								unit      : med.unit
							}
							this.svcFirebaseTools.recCreate('meds_records_log', medRecord)
						}
					})).sort((a, b) => b.icon.localeCompare(a.icon)),
					...payload.conf.map(conf => ({
						uuid: conf.id as string,
						icon: conf.label,
						text: [
							conf.time,
							`${conf.medications.length} Meds`
						],
						func: () => {
							conf.medications.forEach(m => {
								const med = this.svcDataFactory.svcDataMeds.getMedById(m);
								if (med) {
									const medRecord: MedsRecordLogIntf = {
										timestamp : Timestamp.now(),
										medication: m,
										dosage    : med.dosage,
										unit      : med.unit
									}
									this.svcFirebaseTools.recCreate('meds_records_log', medRecord)
								}
							})
						}
					}))
				]

			})


	}


}
